import { User } from "authing-js-sdk";
import validator from "validator";
import { PasswordSecurityLevel } from "@/constants/enum";
import shortid from "shortid";
import qs from "qs";
import { get } from "lodash";
import querystring from "query-string";

/**
 * 支持 await 的休眠函数
 * @param second 秒数
 */
export const sleep = (second: number) =>
  new Promise((resolve) => {
    setTimeout(() => {
      // @ts-ignore
      resolve();
    }, second * 1000);
  });

/**
 * 在屏幕中心弹出新窗口加载 url
 * @param url
 * @param param1
 */
export const popupCenter = (
  url: string,
  { w = 585, h = 649 }: { w?: number; h?: number } = {}
) => {
  // Fixes dual-screen position                             Most browsers      Firefox
  const dualScreenLeft =
    window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const dualScreenTop =
    window.screenTop !== undefined ? window.screenTop : window.screenY;

  const width = window.innerWidth
    ? window.innerWidth
    : document.documentElement.clientWidth
    ? document.documentElement.clientWidth
    : window.screen.width;
  const height = window.innerHeight
    ? window.innerHeight
    : document.documentElement.clientHeight
    ? document.documentElement.clientHeight
    : window.screen.height;

  const systemZoom = width / window.screen.availWidth;
  const left = (width - w) / 2 / systemZoom + dualScreenLeft;
  const top = (height - h) / 2 / systemZoom + dualScreenTop;

  try {
    /**
     * 防止以下情况
     *
     * 1. 桌面端 seafile 的 QtWebEngine 是无法打开新窗口的，但是会返回 window 对象
     * 2. wps Windows 客户端会在浏览器打开新窗口
     */
    if (isQtWebEngine() || window.__config__?.template === "wps") {
      const urlInstance = new URL(url);
      urlInstance.searchParams.append("no_post_message", "1");

      window.location.href = urlInstance.toString();
    } else {
      const newWindow = window.open(
        url,
        "_blank",
        `
          toolbar=no,
          menubar=no,
          scrollbars=no,
          resizable=no,
          location=no,
          status=no
          width=${w / systemZoom},
          height=${h / systemZoom},
          top=${top},
          left=${left}
          `
      );

      newWindow?.focus();

      if (!newWindow) {
        const urlInstance = new URL(url);
        urlInstance.searchParams.append("no_post_message", "1");

        window.location.href = urlInstance.toString();
      }
    }
  } catch (e) {
    // TODO，暂时上面的够用了，这个先注释着
    // const urlInstance = new URL(url);
    // urlInstance.searchParams.append("no_post_message", "1");
    // window.location.href = urlInstance.toString();
  }
};

export const getDisplayName = (user: User) => {
  if (!user) return "";

  return (
    user.nickname ||
    user.name ||
    user.givenName ||
    user.familyName ||
    user.username ||
    user.email ||
    user.phone ||
    user.id
  );
};

export const isEmail = validator.isEmail;

export const PATTERN = {
  phone: /^1[3-9]\d{9}$/,
};

export const isPhone = (value: string) => {
  return PATTERN.phone.test(value);
};

export const isIp = (str: string) => {
  return /^((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})(\.((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})){3}$/.test(
    str
  );
};

export const isHost = (str: string) => {
  return /^[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+.?$/.test(
    str
  );
};
/**
 * 传对象 {'background-color': 'red'}
 * 传字符串 "CSS 样式"
 */
export const addStyles = (styles: string | any) => {
  let styleElt, styleSheet;
  if ((document as any).createStyleSheet) {
    // IE
    styleSheet = (document as any).createStyleSheet();
  } else {
    let head = document.getElementsByTagName("head")[0];
    styleElt = document.createElement("style");
    head.appendChild(styleElt);
    styleSheet = document.styleSheets[document.styleSheets.length - 1];
  }

  if (typeof styles === "string") {
    if (styleElt) styleElt.innerHTML = styles;
    else styleSheet.cssText = styles; // IE
  } else {
    let i = 0;
    for (let selector in styles) {
      if (styleSheet.insertRule) {
        let rule = selector + " {" + styles[selector] + "}";
        styleSheet.insertRule(rule, i++);
      } else {
        styleSheet.addRule(selector, styles[selector], i++);
      }
    }
  }

  return { styleElt, styleSheet };
};

export function getOS() {
  var userAgent = window.navigator.userAgent,
    platform = window.navigator.platform,
    macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
    windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
    iosPlatforms = ["iPhone", "iPad", "iPod"],
    os = null;

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = "Mac OS";
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = "iOS";
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = "Windows";
  } else if (/Android/.test(userAgent)) {
    os = "Android";
  } else if (!os && /Linux/.test(platform)) {
    os = "Linux";
  }

  return os;
}

export const getImgSrc = (path: string) => {
  return `${window.__cdnBase__}${path}`;
};

export const basePath = "http://192.168.50.175:3000";

/**
 * 判断密码强度
 * @param password
 */
export function getPasswordSecurityLevel(
  password: string
): PasswordSecurityLevel {
  const highLevel = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{12,}$/g);
  const middleLevel = new RegExp(/^(?=.*[a-zA-Z])(?=.*\d)[^]{8,}$/g);
  if (password.match(highLevel) !== null) {
    return PasswordSecurityLevel.HIGH;
  }
  if (password.match(middleLevel) !== null) {
    return PasswordSecurityLevel.MIDDLE;
  }
  return PasswordSecurityLevel.LOW;
}

export const getCaptchaUrl = () =>
  `/api/v2/security/captcha?r=${shortid()}&userpool_id=${
    window.__userPoolId__
  }`;

export const isQtWebEngine = () => {
  return /QtWebEngine/i.test(navigator.userAgent);
};

export const isWechatBrowser = () =>
  /MicroMessenger/i.test(navigator.userAgent);

// 企业微信浏览器
export const isWeComeBrowser = () => /wxwork/i.test(navigator.userAgent);

export const isLarkBrowser = () => /Lark/i.test(navigator.userAgent);

export const isIPhonOrIPad = () => /(iphon|ipad)/i.test(navigator.userAgent);

export const openWindow = (url: string) =>
  isIPhonOrIPad() && isLarkBrowser()
    ? (window.location.href = url)
    : window.open(url);

export const getSocialAuthUrl = (
  socialConfig: any,
  authorizationParams: Record<string, any> = {}
) => {
  const query = querystring.parse(window.location.search);

  const queries = {
    app_id: window.__appId__,
    from_guard: "1",
    protocol: query.protocol || "oidc",
    authorization_params: JSON.stringify(authorizationParams),
    uuid: query.uuid,
  };
  return socialConfig.authorizationUrl + "?" + querystring.stringify(queries);
};

// 解析url参数
export const getUserRegisterParams = () => {
  const query = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });
  return query;
};

export const getClassnames = (classnames: (string | boolean | undefined)[]) => {
  return classnames.filter(Boolean).join(" ");
};

// 解析token
export const parseJwt = (token: string) => {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
};

export const transformInterpolation = (
  str: string,
  data: Record<string, any>
) => {
  if (!str) {
    return str;
  }
  return str.replace(/\{\{([$\w.]+?)\}\}/g, (matched, $1) => {
    return get(data, $1, matched);
  });
};

// 埋点信息
export const getBuriedPointInfo = () => {
  const unMapping = [
    "app_id",
    "uuid",
    "sessionData",
    "client_id",
    "nonce",
    "redirect_uri",
    "state",
    "mfaToken",
    "response_type",
    "scope",
  ];

  const search = querystring.parse(window.location.search);

  Object.keys(search).forEach((key) => {
    if (unMapping.includes(key)) {
      delete search[key];
    }
  });

  return search;
};

export const isSemHostname = () =>
  !!querystring.parse(window.location.search)?.sem;
export const isPromotingAds = () =>
  querystring.parse(window.location.search)?.pa;

// 根据是否是中英文、数字开头或结尾填充空格
export const getStringWithWhiteSpace = (
  str: string,
  prefix = true,
  suffix = true
) => {
  if (prefix && str.match(/^[a-zA-Z0-9]/)) {
    str = ` ${str}`;
  }
  if (suffix && str.match(/[a-zA-Z0-9]$/)) {
    str = `${str} `;
  }
  return str;
};
